import axios from "axios";

import {
  RESTORE_AUTHENTICATION,
  REFRESH_TOKEN_SUCCESS,
  REFRESH_TOKEN_FAILURE,
  INCREMENT_REFERRAL,
  SIGN_UP_SUCCESS,
  SIGN_UP_FAILURE,
  CONFIRM_EMAIL_SUCCESS,
  CONFIRM_EMAIL_FAILURE,
  ACCEPT_TERMS_AND_CONDITIONS_SUCCESS,
  ACCEPT_TERMS_AND_CONDITIONS_FAILURE,
  SIGN_IN_SUCCESS,
  SIGN_IN_FAILURE,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
  CREATE_PASSWORD_SUCCESS,
  CREATE_PASSWORD_FAILURE,
  CHANGE_EMAIL_SUCCESS,
  CHANGE_EMAIL_FAILURE,
  SIGN_OUT,
} from "features/application/authentication/redux/types";

export const restoreAuthenticationAction = (token) => ({
  type: RESTORE_AUTHENTICATION,
  payload: token,
});

export const refreshTokenAction = (token) => (dispatch) => {
  axios({
    method: "POST",
    url: "/oauth/token",
    data: {
      grant_type: "refresh_token",
      client_id: process.env.CLIENT_ID,
      client_secret: process.env.CLIENT_SECRET,
      refresh_token: token.refresh,
    },
  })
    .then((response) =>
      dispatch({ type: REFRESH_TOKEN_SUCCESS, payload: response.data })
    )
    .catch((error) =>
      dispatch({ type: REFRESH_TOKEN_FAILURE, payload: error.response.status })
    );
};

export const incrementReferralAction = (hash) => (dispatch) => {
  axios({
    method: "PUT",
    url: "/api/v1/referral-link",
    data: { referral_hash: hash },
  }).then(() => dispatch({ type: INCREMENT_REFERRAL }));
};

export const signUpAction = (
  email,
  password,
  referrer,
  code,
  hash,
  referral,
  eventHash,
  invitationHash
) => (dispatch) => {
  axios({
    method: "POST",
    url: "/api/v1/register",
    data: {
      grant_type: "password",
      client_id: process.env.CLIENT_ID,
      client_secret: process.env.CLIENT_SECRET,
      email,
      password,
      ref_email: referrer,
      code,
      referral_hash: hash,
      invitation_email: referral,
      share_hash: eventHash,
      friend_referral_hash: invitationHash,
    },
  })
    .then((response) => {
      dispatch({ type: SIGN_UP_SUCCESS, payload: response.data.data });
      window.dataLayer.push({ event: "initial_signup" });

      axios({
        method: "POST",
        url: "/api/v1/application/terms",
        data: { accept: true },
      })
        .then((response) =>
          dispatch({
            type: ACCEPT_TERMS_AND_CONDITIONS_SUCCESS,
            payload: response.status,
          })
        )
        .catch((error) =>
          dispatch({
            type: ACCEPT_TERMS_AND_CONDITIONS_FAILURE,
            payload: error.response.status,
          })
        );
    })
    .catch((error) => {
      dispatch({ type: SIGN_UP_FAILURE, payload: error.response.status });
      window.dataLayer.push({ event: "initial_signup_failure" });
    });
};

export const confirmEmailAction = (id, expires, signature) => (dispatch) => {
  axios({
    method: "POST",
    url: `/api/v1/verify/${id}?expires=${expires}&signature=${signature}`,
  })
    .then((response) =>
      dispatch({ type: CONFIRM_EMAIL_SUCCESS, payload: response.status })
    )
    .catch((error) =>
      dispatch({ type: CONFIRM_EMAIL_FAILURE, payload: error.response.status })
    );
};

export const signInAction = (email, password) => (dispatch) => {
  axios({
    method: "POST",
    url: "/oauth/token",
    data: {
      grant_type: "password",
      client_id: process.env.CLIENT_ID,
      client_secret: process.env.CLIENT_SECRET,
      username: email,
      password,
    },
  })
    .then((response) =>
      dispatch({ type: SIGN_IN_SUCCESS, payload: response.data })
    )
    .catch((error) =>
      dispatch({ type: SIGN_IN_FAILURE, payload: error.response.status })
    );
};

export const resetPasswordAction = (email) => (dispatch) => {
  axios({ method: "POST", url: "/api/v1/password/create", data: { email } })
    .then((response) =>
      dispatch({ type: RESET_PASSWORD_SUCCESS, payload: response.status })
    )
    .catch((error) =>
      dispatch({ type: RESET_PASSWORD_FAILURE, payload: error.response.status })
    );
};

export const createPasswordAction = (email, password, token) => (dispatch) => {
  axios({
    method: "POST",
    url: "/api/v1/password/reset",
    data: { email, password, password_confirmation: password, token },
  })
    .then((response) =>
      dispatch({ type: CREATE_PASSWORD_SUCCESS, payload: response.status })
    )
    .catch((error) =>
      dispatch({
        type: CREATE_PASSWORD_FAILURE,
        payload: error.response.status,
      })
    );
};

export const changeEmailAction = (id, email, parameters) => (dispatch) => {
  axios({
    method: "POST",
    url: `/api/v1/change-email/${id}/${email}${parameters}`,
  })
    .then((response) =>
      dispatch({ type: CHANGE_EMAIL_SUCCESS, payload: response.status })
    )
    .catch((error) =>
      dispatch({ type: CHANGE_EMAIL_FAILURE, payload: error.response.status })
    );
};

export const signOutAction = () => ({ type: SIGN_OUT });
